import React from 'react';
import './Education.css'; 
import Navbar from './Navbar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGraduationCap } from '@fortawesome/free-solid-svg-icons';

function Education() {
  return (
    <div>
      <Navbar />
      <div className="education-container">
        <div className="education-item">
          <h2><FontAwesomeIcon icon={faGraduationCap} className="icon" /> B.Tech in Artificial Intelligence</h2>
          <p>Amrita Vishwa Vidyapeetham, kollam, Kerala</p>
          <p>Department of Computer Science and Engineering, 2025 passout</p>
        </div>
        <div className="education-item">
          <h2><FontAwesomeIcon icon={faGraduationCap} className="icon" /> Higher Secondary Certificate</h2>
          <p>Narayana Junior College, Rangareddy, Telanagana</p>
          <p>2021 passout</p>
        </div>
        <div className="education-item">
          <h2><FontAwesomeIcon icon={faGraduationCap} className="icon" /> Secondary School Certificate</h2>
          <p>Alphores High School, Karimnagar, Telangana</p>
          <p>2019 passout</p>
        </div>
      </div>
    </div>
  );
}

export default Education;
